import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { IDatosProyectoAreaEfectivaProyecto } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';

@Component({
  selector: 'app-areas-efectivas',
  templateUrl: './areas-efectivas.component.html',
  styleUrls: ['./areas-efectivas.component.css']
})
export class AreasEfectivasComponent implements OnInit {
  areas: IDatosProyectoAreaEfectivaProyecto[];
  constructor(
    private localStorage: LocalStorage,
    private senaceService:SenaceService
  ) {
    this.localStorage.getItem('detalle').subscribe(
    (resp:any[]) => {
        this.areas = this.senaceService.getAreaEfectiva(resp);
      }
    )
  }

  ngOnInit() {
  }

}
